'use client';

import { useEffect } from 'react';
import { trackEvent } from '@/lib/analytics';

/** 页面级行为埋点：挂载时上报一次功能使用事件（如进入信号页、日历页）。 */
export default function EventPing({ event, target }: { event: string; target?: string }) {
  useEffect(() => {
    trackEvent(event, target);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [event, target]);
  return null;
}
